/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Health_VerifiedInputs */

const id_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terverifikasi`)
};

const ms_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disahkan`)
};

const da_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræftet`)
};

const de_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziert`)
};

const en_us2_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

const es_es2_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificada`)
};

const es_mx2_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificada`)
};

const fil_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-verify`)
};

const fr_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifié`)
};

const it_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificata`)
};

const hu_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellenőrizve`)
};

const nl_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geverifieerd`)
};

const no_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreftet`)
};

const pl_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikowany`)
};

const pt_br2_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado`)
};

const pt_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificada`)
};

const ro_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificat`)
};

const fi_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistettu`)
};

const sv_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifierad`)
};

const vi_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xác minh`)
};

const tr_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulandı`)
};

const cs_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřený`)
};

const bg_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверена`)
};

const ru_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверен`)
};

const uk_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевірено`)
};

const ar_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم التحقق`)
};

const hi_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापित`)
};

const th_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันแล้ว`)
};

const ja_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証済み`)
};

const zh_cn2_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证`)
};

const zh_hant1_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已驗證`)
};

const ko_builds_health_verified = /** @type {(inputs: Builds_Health_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검증됨`)
};

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Builds_Health_VerifiedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_health_verified = /** @type {((inputs?: Builds_Health_VerifiedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Health_VerifiedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_health_verified(inputs)
	if (locale === "ms") return ms_builds_health_verified(inputs)
	if (locale === "da") return da_builds_health_verified(inputs)
	if (locale === "de") return de_builds_health_verified(inputs)
	if (locale === "en-US") return en_us2_builds_health_verified(inputs)
	if (locale === "es-ES") return es_es2_builds_health_verified(inputs)
	if (locale === "es-MX") return es_mx2_builds_health_verified(inputs)
	if (locale === "fil") return fil_builds_health_verified(inputs)
	if (locale === "fr") return fr_builds_health_verified(inputs)
	if (locale === "it") return it_builds_health_verified(inputs)
	if (locale === "hu") return hu_builds_health_verified(inputs)
	if (locale === "nl") return nl_builds_health_verified(inputs)
	if (locale === "no") return no_builds_health_verified(inputs)
	if (locale === "pl") return pl_builds_health_verified(inputs)
	if (locale === "pt-BR") return pt_br2_builds_health_verified(inputs)
	if (locale === "pt") return pt_builds_health_verified(inputs)
	if (locale === "ro") return ro_builds_health_verified(inputs)
	if (locale === "fi") return fi_builds_health_verified(inputs)
	if (locale === "sv") return sv_builds_health_verified(inputs)
	if (locale === "vi") return vi_builds_health_verified(inputs)
	if (locale === "tr") return tr_builds_health_verified(inputs)
	if (locale === "cs") return cs_builds_health_verified(inputs)
	if (locale === "bg") return bg_builds_health_verified(inputs)
	if (locale === "ru") return ru_builds_health_verified(inputs)
	if (locale === "uk") return uk_builds_health_verified(inputs)
	if (locale === "ar") return ar_builds_health_verified(inputs)
	if (locale === "hi") return hi_builds_health_verified(inputs)
	if (locale === "th") return th_builds_health_verified(inputs)
	if (locale === "ja") return ja_builds_health_verified(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_health_verified(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_health_verified(inputs)
	return ko_builds_health_verified(inputs)
});
export { builds_health_verified as "builds.health.verified" }